import { Pipe, PipeTransform } from '@angular/core';
import { SpecificGradingScale } from '@jump-tools-front/shared-interfaces';
import { getScoreForDisplay } from '../../utils';

@Pipe({
  name: 'gameScoreDisplay',
  standalone: true,
})
export class GameScoreDisplayPipe implements PipeTransform {
  transform(score: number, scale: SpecificGradingScale): string {
    return getScoreForDisplay(scale, score);
  }
}
